import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

const _findOneWhere = async function _findOneWhere<T>(
    contentType: ContentTypeProps,
    key: string,
    value: string,
    enableLivePreview: boolean,
    lang: LocaleProps,
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        return (await stackClient.stack
            .ContentType(contentType)
            .Query()
            .language(lang)
            .where(key, value)
            .toJSON()
            .findOne()) as T;
    } catch (err) {
        throw new Error(
            `An error occurred in _findOneWhere: ${JSON.stringify(err)}`,
        );
    }
};

const cached_findOneWhere = unstable_cache(
    _findOneWhere,
    ['search_findOneWhere'],
    {
        revalidate: 1800,
    },
);

export const findOneWhere = async function findOneWhere<T>(
    contentType: ContentTypeProps,
    key: string,
    value: string,
    enableLivePreview: boolean,
    lang: LocaleProps,
): Promise<T> {
    const fn =
        typeof window === 'undefined' ? cached_findOneWhere : _findOneWhere;

    return fn(contentType, key, value, enableLivePreview, lang);
};
